<template>
  <el-col :span="8">
    <el-col :span="8" style="padding-top: 1rem;">
      <h2 class="leader">{{card.leader}}</h2>
    </el-col>
    <el-col :span="16" style="padding: 1rem;">
      <cardContainer :pose="loading">
        <el-card
          :body-style="{ padding: '0px' }"
          class="clickable"
          style="width: 13.5rem; height: 20rem;"
          @click.native="refreshCard(card.type, decks[card.type])">
          <div style="padding: 12px 20px;">
            <h2 class="hyphenate">{{card.title}}</h2>
            <span>{{card.subtitle}}</span>
          </div>
          <div class="bottom pos-abs clearfix">
            <el-button class="el-icon-refresh clickable icon-small" @click="refreshCard(card.type, decks[card.type])" round></el-button>
          </div>
          <img v-bind:src="card.img" class="image">
        </el-card>
      </cardContainer>
    </el-col>
  </el-col>
</template>

<script>
import posed from 'vue-pose'

export default {
  props: ['card', 'decks'],
  components: {
    cardContainer: posed.div({
      'true': { opacity: 1, y: -50, duration: 100 },
      'false': { opacity: 1, y: 0, }
    })
  },
  data() {
    return {
      loading: 'false'
    }
  },
  template: ``,
  methods: {
    refreshCard: function(type, deck) {
      this.$emit('refresh', type, deck)
    }
  },
  watch: {
    card: function() {
      this.loading = 'true'
      setTimeout(() => this.loading = 'false', 150);
    }
  }
}
</script>

<style lang="scss">
  .bottom {
    margin-top: 13px;
    line-height: 12px;

    &.pos-abs {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      text-align: right;
    }
  }

  .el-button.primary {
    background-color: #49738b;
    color: white;
    font-weight: bold;
  }

  .el-button.icon-small {
    position: relative;
    padding: 0.4em;
    right: 1em;
    bottom: 1em;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
    clear: both
  }

  .el-card {
    border-radius: 1rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
  }

  .el-card h2, .el-card span {
    position: relative;
    z-index: 1;
  }

  .el-card .image {
    width: 100%;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    z-index: 0;
  }

  .leader {
    margin: 2rem 1rem;
  }
</style>
